import { AlertIcon } from '../assets/svgImages';
import { OrderItemsPatientViewProps } from '../interface/interface';
import CollapsibleDataTable from './TableWithCollapsibleRows';

const visibleColumns = [
  'Product Name',
  'Ordered Qty',
  'Unit Price',
  'Prescription Status',
  'Repeats Remaining',
  // 'Prescribed Qty Remaining',
  'Used Monthly Limit',
];
const hiddenColumns: string[] = [];

const OrderItemsPatientView = (props: OrderItemsPatientViewProps) => {
  return (
    <>
      <CollapsibleDataTable
        imageColumn="Product Image"
        data={props?.data?.map((d, index) => ({
          'Product Name': (
            <>
              {d.productName} <br />
              {!d.requiresPrescription && (
                <div
                  data-tooltip-id={`non-prescription-product-${index}`}
                  data-tooltip-place="top-start"
                  className="px-2 py-1 mt-2 mx-auto ms-0 rounded-full inline-flex items-center justify-center 
            bg-blue text-pink-50 bg-secondary-pink-700 font-semibold text-sm"
                >
                  <AlertIcon className="fill-pink-50 me-1" />
                  Non-Prescription Product
                </div>
              )}
            </>
          ),
          'Ordered Qty': d.orderedQty,
          'Unit Price': d.price,
          'Prescription Status': d.prescriptionStatus ?? '-',
          'Repeats Remaining': d.remainingRepeats ?? '-',
          // 'Prescribed Qty Remaining': d.remainigUnits ?? '-',
          'Used Monthly Limit': d.monthlyLimit,
          'Product Image': d.imgUrl ?? '/default-image.png',
        }))}
        visibleColumns={visibleColumns}
        hiddenColumns={hiddenColumns}
      />
    </>
  );
};
export default OrderItemsPatientView;
